import { render, staticRenderFns } from "./SearchElement.vue?vue&type=template&id=67198a5f&scoped=true&"
import script from "./SearchElement.vue?vue&type=script&lang=js&"
export * from "./SearchElement.vue?vue&type=script&lang=js&"
import style0 from "./SearchElement.vue?vue&type=style&index=0&id=67198a5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67198a5f",
  null
  
)

export default component.exports